export default {
  computed: {
    currentPageId() {
      return this.$store.state.appRunner.currentPageId
    },

    currentPopPupPageId() {
      return this.$store.state.appRunner.currentPopPupPageId
    },

    getAllPages() {
      return this.$store.getters.getAllPages
    },

    model() {
      return this.$store.getters.appModel
    },
    module() {
      return this.$store.getters.appModel.DefaultModuleImpl
    },
    currentPopupPage() {
      return this.getAllPages.find(p => p.$ID == this.currentPopPupPageId)
    },
    currentPage() {
      return this.getAllPages.find(p => p.$ID == this.currentPageId)
    },
    // Getting all snippets from the app
    snippets() {
      // get snippets from the application  model
      let snippets = []
      let modules = this.model.Modules || {}
      for (let prop in modules) {
        if (!modules[prop] || !modules[prop].Snippets) {
          continue
        }
        modules[prop].Snippets.forEach((snippet) => {
          snippets.push(snippet)
        })
      }
      // get snippets from the changed model
      let changedModules = this.model?.UserModel?.Modules  ?? {}
      if (!changedModules) {
        return snippets
      }

      for (let prop in changedModules) {
        if (!changedModules[prop] || !changedModules[prop].Snippets) {
          continue
        }
        changedModules[prop].Snippets.forEach((snippet) => {
          snippets.push(snippet)
        })
      }

      return snippets
    }

  }
}
